import React, {FunctionComponent} from "react";
import './WizardStepKontakt.scss';
import {MscWizardProps} from "../../interfaces";

const WizardStepKontakt: FunctionComponent<MscWizardProps> = (props) => {
    const nummerRef = React.useRef<HTMLInputElement>(null);
    const [showValidationHinweis, setShowValidationHinweis] = React.useState(false);
    return <div className="msc-anmeldung__wizard-step-two">
        <h1>An welche Handynummer sollen wir die Benachrichtigungen schicken?</h1>
        <div className="msc-anmeldung__wizard-step-two__eingabe">
            <div className="msc-anmeldung__input-btn">
                <input className="msc-anmeldung__input-btn__input"
                   placeholder="Handynummer z.B. +4917699999999"
                   autoComplete="off"
                   value={props.state.kontakt.nummer}
                   type="text"
                   ref={nummerRef}
                   onChange={evt => {
                        props.dispatch({
                            type: "SET_KONTAKT_NUMMER",
                            value: evt.target.value
                        })}
                    }
                />
                <button
                    type="button"
                    disabled={props.state.kontakt.nummer.trim().length <= 0}
                    className="msc-anmeldung__input-btn__btn"
                    onClick={() => {
                        if (props.state.kontakt.valide) {
                            props.dispatch({
                                type: "SET_STEP",
                                value: 'summary'
                            })
                            setShowValidationHinweis(false);
                        } else {
                            setShowValidationHinweis(true);
                        }
                    }}
                >Weiter</button>
            </div>
            {showValidationHinweis ? <p className="msc-anmeldung__wizard-step-two__validierungshinweis">
                Möglicherweise haben Sie eine ungültige Handynummer eingegeben. Bitte überprüfen Sie Ihre Eingabe und versuchen es erneut.
            </p> : <></>}
        </div>
    </div>
};

export default WizardStepKontakt
